import type {
  IHealth,
  IHealthFactory,
  HealthConfig,
  FeatureUsageAndHealthConfig,
  IExtendedHealth
} from "./generated/healthSmall.gen";
import { Health } from "./health";
import { ExtendedHealth } from "./health.extensions";

export class HealthFactory implements IHealthFactory {
  getHealthInstance(
    healthConfig: HealthConfig | null | undefined
  ): IHealth | undefined {
    if (!healthConfig) {
      return undefined;
    }

    Health.getInstance().initialize(healthConfig);

    return Health.getInstance();
  }

  getExtendedHealthInstance(
    healthLogger: IHealth | null | undefined,
    featureConfig: FeatureUsageAndHealthConfig | null | undefined
  ): IExtendedHealth | undefined {
    if (!healthLogger || !featureConfig) {
      return undefined;
    }

    return ExtendedHealth.getInstance(healthLogger, featureConfig);
  }
}
